import {
  File,
  FileImage,
  FileSpreadsheet,
  FileText,
  type LucideIcon,
} from 'lucide-react'
import {
  PRODUCT_SOURCE_XLSM_MIME,
  PRODUCT_SOURCE_XLSX_MIME,
} from './productSourceFileTypes'

export function getProductSourceIcon(sourceType: string): LucideIcon {
  if (sourceType === 'application/pdf') {
    return FileText
  }
  if (sourceType === 'image/jpeg' || sourceType === 'image/png') {
    return FileImage
  }
  if (
    sourceType === PRODUCT_SOURCE_XLSX_MIME ||
    sourceType === PRODUCT_SOURCE_XLSM_MIME
  ) {
    return FileSpreadsheet
  }
  return File
}
